import { TabBarContainer } from '@styled_components/helpCentre/styled.components'
import Tab from '../Tab/Tab'
import { useTranslation } from 'react-i18next'

type Category = 'student' | 'author' | 'referralPartner' | 'legal'

interface TabBarProps {
  currentCategory: Category
  setCategory(category: Category): any
}

const TabBar = ({ currentCategory, setCategory }: TabBarProps) => {
  const { t } = useTranslation('helpCentre')

  const CategoryTitles = {
    student: t('student'),
    author: t('author'),
    referralPartner: t('referralPartner'),
    legal: t('legal'),
  }

  return (
    <TabBarContainer>
      <Tab
        active={currentCategory == 'student'}
        setActiveTab={() => {
          setCategory('student')
        }}
      >
        {CategoryTitles.student}
      </Tab>
      <Tab
        active={currentCategory == 'author'}
        setActiveTab={() => {
          setCategory('author')
        }}
      >
        {CategoryTitles.author}
      </Tab>
      <Tab
        active={currentCategory == 'referralPartner'}
        setActiveTab={() => {
          setCategory('referralPartner')
        }}
      >
        {CategoryTitles.referralPartner}
      </Tab>
      <Tab
        active={currentCategory == 'legal'}
        setActiveTab={() => {
          setCategory('legal')
        }}
      >
        {CategoryTitles.legal}
      </Tab>
    </TabBarContainer>
  )
}

export default TabBar
